import { Link } from "react-router-dom";
import { useEnv } from "@/hooks/useEnv";

export default function PrivacyPage() {
  const { contactEmail } = useEnv();

	const sections = [
		{
			title: "1. Общие положения",
			content: `Настоящая Политика конфиденциальности (далее — «Политика») описывает, каким образом BroMoney собирает, использует и хранит данные Пользователей своего сервиса.

Используя BroMoney, вы подтверждаете своё согласие с условиями настоящей Политики. Если вы не согласны с какими-либо условиями, рекомендуем воздержаться от использования Сервиса.

Политика распространяется на все продукты BroMoney: веб-платформу, мобильное приложение и смежные интеграции.`,
		},
		{
			title: "2. Какие данные мы собираем",
			content: `В процессе использования Сервиса мы можем собирать следующие данные:

**Личные данные:** имя и фамилия, дата рождения, реквизиты документа, удостоверяющего личность.

**Контактные данные:** адрес электронной почты, номер телефона.

**Финансовые данные:** информация об операциях, баланс счёта, реквизиты для ввода и вывода средств.

**Технические данные:** IP-адрес, тип устройства и браузера, данные сессии, файлы cookie.

**Данные верификации:** фотография документа и селфи при прохождении подтверждения личности.

Объём собираемых данных зависит от уровня доступа и используемых функций Сервиса.`,
		},
		{
			title: "3. Как мы используем данные",
			content: `Собираемые данные используются в следующих целях:

— Создание и поддержание учётной записи Пользователя;
— Обработка операций и поддержание работоспособности Сервиса;
— Обеспечение безопасности аккаунта и противодействие несанкционированным действиям;
— Связь с Пользователем по вопросам поддержки и уведомлений;
— Улучшение функциональности и интерфейса Сервиса;
— Информирование об обновлениях и специальных предложениях (при наличии согласия).`,
		},
		{
			title: "4. Основания для обработки данных",
			content: `BroMoney обрабатывает данные Пользователей на следующих основаниях:

**Исполнение договора:** обработка необходима для предоставления услуг согласно Пользовательскому соглашению.

**Законный интерес:** обработка используется для обеспечения безопасности, стабильности и развития Сервиса.

**Согласие:** в отдельных случаях (например, маркетинговые рассылки) мы запрашиваем явное согласие, которое вы вправе отозвать в любой момент.`,
		},
		{
			title: "5. Хранение и защита данных",
			content: `Мы применяем технические и организационные меры для надёжной защиты данных Пользователей:

— Шифрование данных при хранении и передаче;
— Двухфакторная аутентификация для доступа к аккаунту;
— Ограниченный доступ сотрудников к пользовательским данным;
— Регулярные проверки безопасности.

Данные хранятся в течение срока, необходимого для выполнения целей, указанных в настоящей Политике, либо до удаления аккаунта Пользователем.`,
		},
		{
			title: "6. Передача данных третьим лицам",
			content: `BroMoney может передавать отдельные данные Пользователей следующим категориям получателей:

**Технические партнёры:** провайдеры облачной инфраструктуры, аналитики и технической поддержки, действующие в рамках наших инструкций.

**Сервисы верификации:** партнёры, осуществляющие проверку личности при прохождении подтверждения аккаунта.

**Платёжные провайдеры:** для проведения операций по вводу и выводу средств.

Мы не продаём персональные данные Пользователей третьим лицам в коммерческих целях.`,
		},
		{
			title: "7. Трансграничная обработка данных",
			content: `BroMoney является международным сервисом. Данные Пользователей могут обрабатываться в странах, отличных от страны их проживания.

В таких случаях мы обеспечиваем приемлемый уровень защиты данных посредством соответствующих соглашений с партнёрами и технических мер защиты.`,
		},
		{
			title: "8. Права пользователей",
			content: `Вы вправе в любой момент:

**Запросить доступ:** узнать, какие данные мы храним о вас.
**Исправить данные:** обновить устаревшую или некорректную информацию.
**Удалить данные:** запросить удаление данных при отсутствии оснований для их дальнейшего хранения.
**Ограничить обработку:** приостановить использование данных в определённых целях.
**Отозвать согласие:** отказаться от получения маркетинговых сообщений.

Для реализации своих прав напишите нам на ${contactEmail} Мы рассмотрим обращение в разумные сроки.`,
		},
		{
			title: "9. Файлы cookie",
			content: `BroMoney использует файлы cookie для корректной работы Сервиса, аналитики и повышения безопасности.

Вы можете управлять настройками cookie через браузер. Обратите внимание, что отключение некоторых из них может ограничить функциональность Сервиса.`,
		},
		{
			title: "10. Изменения Политики",
			content: `Мы оставляем за собой право вносить изменения в настоящую Политику. При существенных изменениях Пользователи получат уведомление заблаговременно — по электронной почте или через интерфейс приложения.

Продолжая пользоваться Сервисом после обновления Политики, вы принимаете новые условия.`,
		},
		{
			title: "11. Контактные данные",
			content: `По всем вопросам, связанным с обработкой данных, обращайтесь:

Email: ${contactEmail}
Сайт: bromoney.net

Мы стараемся отвечать на обращения в течение нескольких рабочих дней.`,
		},
	];

  return (
    <div className="min-h-screen bg-white">
      <div className="bg-[#f8fafd] border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[#007AFF] text-sm font-medium mb-6 hover:opacity-80 transition-opacity cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            На главную
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#007AFF]/10 rounded-xl">
              <i className="ri-shield-user-line text-[#007AFF] text-xl" />
            </div>
            <span className="text-[#007AFF] text-sm font-semibold uppercase tracking-wide">BroMoney</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-3">Политика конфиденциальности</h1>
          <p className="text-gray-400 text-sm">Последнее обновление: 1 января 2025 года</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-14">
        <div className="bg-[#eff6ff] border border-[#c7dcff] rounded-xl px-6 py-4 mb-10">
          <p className="text-[#007AFF] text-sm leading-relaxed">
            <strong>Важно:</strong> Настоящая Политика описывает, как BroMoney работает с вашими данными. Пожалуйста, ознакомьтесь перед использованием Сервиса.
          </p>
        </div>

        <div className="flex flex-col gap-10">
          {sections.map((sec) => (
            <div key={sec.title}>
              <h4 className="text-lg font-bold text-gray-900 mb-3">
                <a
                  id={sec.title.toLowerCase().replace(/\s+/g, "-")}
                  href={`#${sec.title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="hover:text-[#007AFF] transition-colors"
                >
                  {sec.title}
                </a>
              </h4>
              <div className="text-gray-500 text-[15px] leading-relaxed">
                {sec.content.split("\n").map((line, idx) => {
                  if (line.startsWith("**") && line.endsWith("**")) {
                    return (
                      <p key={idx} className="font-semibold text-gray-700 mt-3 mb-1">
                        {line.replace(/\*\*/g, "")}
                      </p>
                    );
                  }
                  if (line.startsWith("**") && line.includes(":**")) {
                    const [bold, ...rest] = line.split(":**");
                    return (
                      <p key={idx} className="mt-2">
                        <strong className="text-gray-700">{bold.replace("**", "")}:</strong>
                        {rest.join(":**")}
                      </p>
                    );
                  }
                  if (line.startsWith("— ")) {
                    return (
                      <div key={idx} className="flex items-start gap-2 mt-1.5">
                        <span className="text-[#007AFF] mt-0.5 shrink-0">—</span>
                        <span>{line.slice(2)}</span>
                      </div>
                    );
                  }
                  return line ? (
                    <p key={idx} className="mt-1.5">
                      {line}
                    </p>
                  ) : (
                    <div key={idx} className="h-1" />
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-gray-100 bg-[#f8fafd]">
        <div className="max-w-4xl mx-auto px-6 py-6 flex flex-wrap items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">&copy; {new Date().getFullYear()} BroMoney. Все права защищены.</p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="text-gray-400 hover:text-[#007AFF] text-xs transition-colors cursor-pointer">
              Пользовательское соглашение
            </Link>
            <a href={`mailto:${contactEmail}`} className="text-gray-400 hover:text-[#007AFF] text-xs transition-colors cursor-pointer">
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
